import type { SVGProps } from 'react';
import * as React from 'react';

const ThreedmIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/threedm">
      <g id="Vector" filter="url(#filter0_dd_3816_38053)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#10B981"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38053)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <path
        id="Vector_2"
        d="M29.4706 25.5709C28.3543 25.7702 27.4726 26.923 26.2995 26.1438C26.783 25.361 27.1989 24.6921 27.7144 23.8595C27.2913 23.8595 27.1527 23.8311 27.0283 23.8631C24.3442 24.6067 24.2589 24.596 22.9684 22.2122C22.5951 21.5255 22.2218 21.3049 21.5499 21.7923C21.3188 21.9596 21.0486 22.0734 20.7998 22.2122C22.4031 20.4723 22.4458 20.2766 21.4433 18.2023C21.1802 17.6579 20.8638 17.1171 20.4834 16.651C19.9608 16.0106 19.3529 15.4377 18.553 14.5981C18.3041 15.9537 18.2757 16.9819 17.9166 17.8785C17.3372 19.3302 16.5799 20.7143 15.8049 22.077C15.6805 22.294 15.0797 22.2371 14.6993 22.3082C14.6744 21.9524 14.5607 21.5717 14.6495 21.248C14.7526 20.8815 15.0441 20.5719 15.2397 20.2268C16.1995 18.519 16.6333 16.7008 16.3844 14.7404C16.2778 13.9007 15.8263 13.5129 14.9802 13.7228C14.0416 13.9541 13.1102 14.2102 12.1823 14.47C11.5957 14.6336 11.5637 14.9254 11.7699 15.5125C12.1183 16.5087 12.4276 17.569 12.4738 18.6115C12.5556 20.5328 12.3921 20.6253 10.4652 20.8174C10.4652 21.4828 10.4012 22.1695 10.4972 22.8348C10.5363 23.1017 10.9025 23.4895 11.1656 23.5322C13.1706 23.8489 14.6566 24.9803 15.8974 26.4818C16.4484 27.1471 16.9106 27.8872 17.522 28.7518C17.5896 28.3675 17.6891 28.154 17.65 27.9726C17.4509 27.0333 17.3052 26.0726 16.9745 25.1795C16.6546 24.3078 16.8003 23.8204 17.6962 23.5429C18.3077 23.3543 18.9014 23.1017 19.5022 22.8775C19.104 23.1123 18.6525 23.2867 18.3219 23.5927C17.7495 24.1264 17.9166 24.8664 18.6276 25.1368C18.8907 25.2365 19.1787 25.2685 19.456 25.3325C19.392 25.4179 19.328 25.5033 19.264 25.5887C19.7795 26.0441 20.295 26.4996 20.8105 26.955C21.7312 27.7698 21.9445 26.1865 22.6875 26.4035C22.4493 26.8198 22.1436 27.2147 21.9836 27.6595C21.7561 28.2857 21.653 28.9617 20.7145 28.7162C19.296 28.3497 18.7734 27.8125 18.8232 26.8305C18.8481 26.3679 18.7592 25.9018 18.7236 25.4393C18.4108 25.9837 18.4179 26.4924 18.2864 26.9657C18.0091 27.9619 18.3575 28.5205 19.2391 29.0613C20.8851 30.0682 22.428 31.2495 24.0207 32.3525C24.3477 32.5802 24.6926 32.783 25.0303 33C25.1192 32.9324 25.2081 32.8648 25.2969 32.7937C25.1583 32.4307 24.9414 32.0785 24.8988 31.7049C24.849 31.2744 24.9272 30.8225 25.0196 30.392C25.0374 30.3137 25.5067 30.207 25.5742 30.2853C25.8586 30.6126 26.0826 30.9933 26.2924 31.374C26.3457 31.4701 26.2533 31.6409 26.2426 31.6978C25.9297 31.5341 25.624 31.3776 25.0943 31.1C25.7378 32.5731 26.1715 32.6656 26.9074 31.7227C27.1669 31.3882 27.2913 30.9577 27.5046 30.5877C27.8566 29.9793 28.1019 29.2108 28.6245 28.8194C29.8652 27.905 29.5452 26.7629 29.4706 25.5709ZM20.8425 26.5316L19.975 25.7204C21.365 26.7202 21.7703 26.5316 21.7703 26.5316C21.397 26.9336 20.8425 26.5316 20.8425 26.5316Z"
        fill="white"
      />
      <g id="border">
        <path
          d="M7.33691 1.5H26.0186L34.8369 10.3184V38.333C34.8369 39.5323 33.8746 40.5 32.6807 40.5H7.33008C6.20656 40.5 5.29068 39.6581 5.18066 38.5684L5.16992 38.3477V3.64941C5.17013 2.4571 6.13628 1.5 7.33691 1.5Z"
          stroke="black"
          strokeOpacity={0.06}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38053"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38053" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38053" result="effect2_dropShadow_3816_38053" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38053" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38053"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default ThreedmIcon;
